import { Injectable, Inject, APP_INITIALIZER } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of, ObservableLike } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConfigService } from "./config/config.service";

@Injectable()
export class AppService {

    constructor(private http: HttpClient,   public config: ConfigService) { }

   
}